/**
 * @file Locale utilities module exports
 */

export { LocaleUtils } from './locale-utils';